import React from "react";
import { ReconciliationModal } from "./ReconciliationModal";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const opsComponents: Record<string, React.ComponentType<any>> = {
  ReconciliationModal,
};

export default opsComponents;
